<template>
  <el-aside width="18%" style="overflow-x: hidden">
    <el-menu :default-openeds="['0']">
      <el-submenu index="0">
        <template slot="title"
          ><em class="el-icon-document"></em>{{ label }}</template
        >
        <el-menu-item-group :class="'custom-el-menu-item-group-cal'">
          <el-menu-item
            @click="handleChangeMenuSelected(item.id, i)"
            v-for="(item, i) in list"
            :key="`${item.id}-${i}`"
            v-bind:index="`${item.id}`"
            style="min-width: 140px"
            :class="'custom-el-menu-item-cal ' + addClass"
          >
            <abbreviated-text-tooltip :text="item.name" />
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>
<script>
import AbbreviatedTextTooltip from 'src/components/Texts/AbbreviatedTextTooltip.vue';

export default {
  name: 'aside-list',
  components: {
    [AbbreviatedTextTooltip.name]: AbbreviatedTextTooltip,
  },
  props: {
    optionIndex: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    addClass: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: [],
    },
  },
  methods: {
    handleChangeMenuSelected(id, i) {
      this.$emit('clickItem', {
        id: id,
        index: i,
        option: this.optionIndex,
        type: 'aside',
      });
    },
  },
};
</script>
